import { R } from './RegSymbol.jsx'

type Props = {
  freight?: boolean
  direct?: boolean
}
export const FedEx = ({ freight, direct }: Props) => {
  return (
    <>
      FedEx
      {(freight || direct) && <> Freight</>}
      <R />
      {direct && <> Direct</>}
    </>
  )
}
